module.exports = __webpack_public_path__ + "static/media/07.e98e3412.jpg";